import Loading from '../../../Common/Loading';
import { useRegulationChartsDataContext } from './hooks/useRegulationChartsDataContext';
import { LocationIndex } from './LocationIndex';
import { RegulationIndex } from './RegulationIndex';
import { TotalOcurrencesMedicalRegulation } from './TotalOcurrencesMedicalRegulation';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useRegulationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="side-by-side-group">
                <LocationIndex />
                <RegulationIndex />
            </div>
            <div className="side-by-side-group">
                <TotalOcurrencesMedicalRegulation />
            </div>
        </>
    );
};
